import { shape, string } from "prop-types"

export const CostCodeGroupShape = shape({
    costCodeGroupId: string.isRequired,
    name: string.isRequired,
    description: string
})